<template>
  <div>
    <v-menu bottom min-width="200px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon x-large v-on="on">
          <v-avatar>
            <v-img
                :src="profilePictureUrl || require('@/assets/profile_placeholder.png')"
                alt="require('@/assets/profile_placeholder.png')"
            ></v-img>
          </v-avatar>
        </v-btn>
      </template>
      <v-card rounded="xl">
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-center" >
            <v-avatar @click="openProfileCard(store.state.userData.userId)">
              <v-img
                  :src="profilePictureUrl || require('@/assets/profile_placeholder.png')"
                  alt="require('@/assets/profile_placeholder.png')"
              ></v-img>
            </v-avatar>
            <p class="text-caption mt-1">
              {{ store.state.userData.userEmail }}
            </p>
            <v-divider class="my-3"></v-divider>
            <v-btn style="text-transform: capitalize" depressed rounded text @click="openEditAccountDialog()">Edit Profile</v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn style="text-transform: capitalize" depressed rounded text @click="showMyEvents = true">My Contributions</v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn style="text-transform: capitalize" depressed rounded text @click="store.commit('setAboutDialogVisibility', true)">About</v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn style="text-transform: capitalize" @click="signOut" depressed rounded text>Log Out</v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
    <v-dialog v-model="showMyEvents" fullscreen transition="slide-x-reverse-transition">
      <v-card class="blue lighten-4">
        <v-app-bar class="rounded-b-lg" style="background-color: #def6f4">
          <v-app-bar-nav-icon @click="showMyEvents = false; store.commit('setAddContributionVisibility', false)"><v-icon>mdi-close</v-icon></v-app-bar-nav-icon>
          <v-toolbar-title>My Contributions</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="store.commit('setAddContributionVisibility', true)" v-if="!store.state.addContributionVisible">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-app-bar>
        <AddEvent v-if="store.state.addContributionVisible"></AddEvent>
        <MyContributions v-else></MyContributions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editAccountDialogVisible" max-width="600px">
      <v-card class="bg" rounded="xxl">
        <v-card-title class="headline">
          Edit Profile
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="saveProfile">
            <v-avatar size="100" class="profile-avatar">
              <input type="file" accept="image/*" style="display: none" ref="fileInput" @change="onFileChange"/>
              <v-img
                  :src="profilePictureUrl || require('@/assets/profile_placeholder.png')"
                  alt="Profile Picture"
                  @click="openFileInput"
              ><v-icon size="28" class="mt-5" style="transform: translateY(15px)">mdi-camera</v-icon></v-img>
            </v-avatar>
            <v-text-field v-model="userFullName" label="Full Name" required></v-text-field>
<!--
            <v-text-field v-model="userOriginCountry" label="Origin Country"></v-text-field>
-->
            <v-autocomplete
                v-model="userOriginCountry"
                :items="countries"
                label="Origin Country"
                auto-select-first
                class="countryAutocomplete"
            ></v-autocomplete>
            <v-text-field v-model="facebookAccount" label="Facebook"></v-text-field>
            <v-text-field v-model="instagramAccount" label="Instagram"></v-text-field>
            <p style="margin-bottom: 0" class="text-caption mt-1">Privacy Setting</p>

            <div style="display: flex; justify-content: center">
              <v-checkbox class="closeTop" v-model="userPrivacyDefault" on-icon="mdi-eye" off-icon="mdi-eye-off"></v-checkbox>
            </div>
            <v-card-subtitle v-if="userPrivacyDefault" class="onboardingDialogSubtitle">Other People Will See Your Journey</v-card-subtitle>
            <v-card-subtitle v-else class="onboardingDialogSubtitle">Other People Won't See Your Journey</v-card-subtitle>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn style="text-transform: capitalize" rounded color="primary" class="ml-3 mb-2"  @click="closeEditAccountDialog()">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn style="text-transform: capitalize" rounded color="primary" class="mr-3 mb-2"  @click="saveProfile()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ProfileCard :profile-card-key="this.profileCardKey" :userProfileData="this.userProfileData"></ProfileCard>
  </div>
</template>

<script>
import supabase from "@/lib/supabaseClient";
import {store} from "@/store";
import ProfileCard from "@/components/ProfileCard.vue";
import {countries} from "@/assets/countries"
import AddEvent from "@/components/AddEvent.vue";
import MyContributions from "@/components/MyContributions.vue";
export default {
  name: "UserCard",
  components: {MyContributions, AddEvent, ProfileCard},
  computed: {
    store() {
      return store
    }
  },
  data() {
    return {
      countries,
      editAccountDialogVisible: false,
      profilePictureUrl: store.state.userData.profilePictureUrl,
      userEmail: store.state.userData.userEmail,
      userFullName: store.state.userData.userFullName,
      facebookAccount: store.state.userData.facebookAccount,
      instagramAccount: store.state.userData.instagramAccount,
      userOriginCountry: store.state.userData.originCountry,
      userPrivacyDefault: store.state.userData.privacyDefault,
      userId: '',
      user: '',
      userProfileData: {},
      profileCardKey: 0,
      showMyEvents: false,
      showAbout: false,
    }
  },

  methods: {
    openEditAccountDialog() {
      this.editAccountDialogVisible = true;
    },
    closeEditAccountDialog() {
      this.editAccountDialogVisible = false;
    },
    /*openProfileCard() {
      this.profileCardKey++
      this.userProfileData = {}
      this.userProfileData.avatar_url = this.profilePictureUrl
      this.userProfileData.full_name = this.userFullName
      this.userProfileData.email = this.userEmail
      this.userProfileData.origin_country = this.userOriginCountry
      this.userProfileData.privacy_default = this.userPrivacyDefault
      store.commit('profileDialogOn')
    },*/
    async openProfileCard(userId) {
      console.log(userId)
      await store.dispatch('getProfileCardData', userId)
      store.commit('profileDialogOn')
    },
    onFileChange(event) {
      // Handle the selected file
      this.profilePicture = event;
      console.log(event)

      const file = event.target.files[0];

      if (file) {
        // Use URL.createObjectURL to generate a temporary URL for the selected image
        this.profilePictureUrl = URL.createObjectURL(file);
      } else {
        // Handle the case where no file was selected
        this.profilePictureUrl = null;
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    async saveProfile() {
      if (this.profilePicture) {
        const fileName = store.state.userData.userId + '.' + this.profilePicture.target.files[0].name.split('.')[1]; // Replace with your logic
        await supabase.storage.from('avatars').upload(fileName, this.profilePicture.target.files[0], {upsert: true})

        this.profilePictureUrl = process.env.VUE_APP_SUPABASE_URL + "/storage/v1/object/public/avatars/" + fileName
      }
      if (this.instagramAccount && !this.instagramAccount?.startsWith("http")) {
        if (this.instagramAccount.startsWith("instagram.com")) {
          this.instagramAccount = 'https://' + this.instagramAccount
        } else {
          this.instagramAccount = 'https://instagram.com/' + this.instagramAccount
        }
      }
      if (this.facebookAccount && !this.facebookAccount?.startsWith("http")) {
        if (this.facebookAccount.startsWith("facebook.com")) {
          this.facebookAccount = 'https://' + this.facebookAccount
        } else {
          this.facebookAccount = 'https://facebook.com/' + this.facebookAccount
        }
      }
      console.log(this.userPrivacyDefault)
      const { error } = await supabase
          .from('users_data')
          .update({
            full_name: this.userFullName,
            avatar_url: this.profilePictureUrl,
            origin_country: this.userOriginCountry,
            privacy_default: this.userPrivacyDefault,
            facebook_account: this.facebookAccount,
            instagram_account: this.instagramAccount,
          })
          .eq('id', store.state.userData.userId)
      if (error) {
        console.log(error)
      }
      await store.dispatch('getUserData')
      this.editAccountDialogVisible = false;
    },
    async signOut() {
      const { error } = await supabase.auth.signOut()
      if (error) {
        console.error("Error Logging Out:", error);
        return
      }
      await this.$router.push('/registration');
    },
  }
}
</script>

<style scoped>
.v-list {
  background-color: #A9C9FF!important;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%)!important;
}
</style>

<style>

.profile-avatar {
  width: 100px;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.camera-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.closeTop {
  margin-top: 5px!important;
}

.bg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}

</style>
